import Vue from 'vue';
import Router from 'vue-router';
import Evaluation from '@/views/evaluation/index.vue';
import NoveltySearch from '@/views/noveltySearch/index.vue';
import Register from '@/views/register/index.vue';
import Award from '@/views/award/index.vue';
import Expert from '@/views/expert/index.vue';
import Case from '@/views/case/index.vue';
import About from '@/views/about/index.vue';
import Contact from '@/views/contact/index.vue';
import CaseDetails from '@/views/case/details.vue';
import Answer from '@/views/answer/index.vue';
import Download from '@/views/download/index.vue';
import NewsDetails from '@/views/evaluation/details.vue';
import AnswerDetails from '@/views/answer/details.vue';
import Search from '@/views/search/index.vue';



Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/evaluation'
  },
  {
    path: '/evaluation',
    component: Evaluation
  },
  {
    path: '/noveltySearch',
    component: NoveltySearch
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/award',
    component: Award
  },
  {
    path: '/expert',
    component: Expert
  },
  {
    path: '/case',
    component: Case
  },
  {
    path: '/about',
    component: About
  },
  {
    path: '/contact',
    component: Contact
  },
  {
    path: '/caseDetails',
    component: CaseDetails
  },
  {
    path: '/answer',
    component: Answer
  },
  {
    path: '/download',
    component: Download
  },
  {
    path: '/newsDetails',
    component: NewsDetails
  },
  {
    path: '/answerDetails',
    component: AnswerDetails
  },
  {
    path: '/search',
    component: Search
  }
]

export default new Router({ routes })
